import React, { lazy } from "react";
import { ENUM_GAME_TYPE } from "../store/enums";
import PageWitchMenu from "../components/mui/page_witch_menu/PageWitchMenu";
import useScrollUp from "../hooks/useScrollUp";
import ErrorBoundary from "../components/mui/error_boundary/ErrorBoundary";
import LoaderContainer from "../components/mui/loader_container/LoaderContainer";
import { useAppSelector } from "../store/index.ts";
import CusSuspense from "../components/mui/CusSuspense.jsx";
import Banners from "../components/landing/banners/Banners";
import Header from "../components/landing/header/Header.jsx";
import CatalogGame from "../components/landing/catalog_game/CatalogGame";
import useJackpotInterval from "../hooks/common/useJackpotInterval.js";
import "./main.scss";
import useCheckPathname from "../hooks/useCheckPathname.js";

const TypeGamesMenu = lazy(() => import("../components/landing/type_games_menu/TypeGamesMenu"));
const LastChampions = lazy(() => import("../components/landing/last_champions/LastChampions"));
const Jackpot = lazy(() => import("../components/landing/jackpot/Jackpot"));
const FindGameLine = lazy(() => import("../components/landing/find_game_line/FindGameLine"));
const Favorites = lazy(() => import("../components/landing/favorites/Favorites"));
const Footer = lazy(() => import("../components/landing/footer/Footer"));

export default function Main() {
  useScrollUp();
  useJackpotInterval();
  useCheckPathname();

  const loader = useAppSelector((state) => state.site.mainLoader);
  const errorInfo = useAppSelector((state) => state.site.errorInfo);

  return (
    <LoaderContainer center loader={loader || errorInfo} fullHeight>
      <PageWitchMenu className={"landing"}>
        <ErrorBoundary>
          <Header />
        </ErrorBoundary>
        {/* <CusSuspense fallback={<div style={{ minHeight: 100 }} className="last-champion"></div>}>
          <LastChampions />
        </CusSuspense> */}
        <ErrorBoundary>
          <Banners />
        </ErrorBoundary>
        <CusSuspense>
          <Jackpot />
        </CusSuspense>
        <CusSuspense>
          <TypeGamesMenu activeTab={ENUM_GAME_TYPE.lobby} />
        </CusSuspense>
        <CusSuspense>
          <FindGameLine />
        </CusSuspense>
        <ErrorBoundary>
          <CatalogGame />
        </ErrorBoundary>
        <CusSuspense>
          <Favorites />
        </CusSuspense>
        {/* <LatestRates /> */}
        <CusSuspense>
          <Footer />
        </CusSuspense>
      </PageWitchMenu>
    </LoaderContainer>
  );
}
